// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"information-text_infoWrapper__OUlJX"};